import { DAYS_RETENTION_VALUE, LIMIT_TO_USERS_VALUE } from '@/consts';
import { Policy, PolicySetting } from '../../../types/types';

export const getDaysRangeSetting = (policy: Policy): PolicySetting => (
    policy?.settings?.access?.find(({ id }) => id === DAYS_RETENTION_VALUE)
);

export const getLimitToUsersSetting = (policy: Policy): PolicySetting => (
    policy?.settings?.access?.find(({ id }) => id === 'limitToUsers')
);

export const getLimitToUsersValueSetting = (policy: Policy): PolicySetting => (
    policy?.settings?.access?.find(({ id }) => id === LIMIT_TO_USERS_VALUE)
);
